import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import env from '../../../../util/env';
import {serviceURL} from '../../../../util/uiconstants';
import {labels} from '../../../../util/utils';
import Modal from '../../Modal/Modal';
import Loader from '../../LoadingIndicator/LoadingIndicator';
import * as AccountAction from '../../../../actions/Account/accountactions';
import * as RiskTypeAction from '../../../../actions/RiskType/risktypeactions';
import {useEngagementId} from '../../../../util/customHooks';

function DeleteAccountModal(props) {
	const dispatch = useDispatch();
	const engagementId = useEngagementId();
	const [isLoading, setIsLoading] = useState(false);

	async function onSaveChangesHandler() {
		setIsLoading(true);
		dispatch(AccountAction.deleteAccount(Number(engagementId), props.account.value));
		await getAllAccounts();
		if (!props.callFrom) {
			await getRiskTypesWithAssertionsAndAccounts();
		}
		setIsLoading(false);
		props.setToasterLabel(props.account.label + labels.deleteAccountLabel);
		props.setToasterVisible(true);
		dispatch(AccountAction.cleanAccount());
		props.onClose();
	}

	const onCloseHandler = () => {
		props.onClose();
	};

	async function getRiskTypesWithAssertionsAndAccounts() {
		const queryParameters = 'risks,risks.assertions,risks.assertions.account,risks.riskfactors';
		dispatch(
			RiskTypeAction.getRiskTypes_old(
				env.getBaseURL(serviceURL, Number(engagementId)) + 'RiskTypes?isActive=true&expand=' + queryParameters
			)
		);
	}

	async function getAllAccounts() {
		dispatch(AccountAction.getAccounts(engagementId, {orderBy: 'AccountName', IncludeAssertions: true}));
	}

	return (
		<>
			<Modal
				show={props.show}
				title={labels.deleteAccount}
				closeTitle={labels.modalCloseTitle}
				modalContainerClass="deleteaccount-modal"
				modalsize={'x-small'}
				showButtons
				confirmBtnTitle={labels.delete}
				closeBtnTitle={labels.modalCancelTitle}
				onOkClick={onSaveChangesHandler}
				onHide={onCloseHandler}
				modalonmodal
				isCancelButtonDisabled={isLoading}
				isOkButtonDisabled={isLoading}
				isAresView={props.isAresView}
			>
				<Loader show={isLoading} />
				<span>{labels.deleteAccountModalMessage}</span>
				<span>{labels.cannotBeUndone}</span>
			</Modal>
		</>
	);
}

export default DeleteAccountModal;
